module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_vm._l((_vm.curList), function(el, k) {
    return _c('label', {
      key: k,
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.curValue),
        expression: "curValue"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.name
      },
      domProps: {
        "value": el.id,
        "checked": _vm._q(_vm.curValue, el.id)
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(el.id)
        },
        "change": function($event) {
          _vm.curValue = el.id
        }
      }
    }), _vm._v(" " + _vm._s(_vm._f("ftc")(el.name)) + "\n\t")])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9cdb2a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterRadio.vue
// module id = 474
// module chunks = 0